export const SET_OBJECTIVES = 'MODULE_LEARNING_OBJECTIVES_SET_OBJECTIVES';
